import { Slider, Tooltip } from "antd";
import { MdHelpOutline } from "react-icons/md";
import { useState } from "react";

const LEVELS = [
    {
        label: "Minimum",
        value: 1,
        description:
            "Vous consultez des médecins ne pratiquant pas de dépassements d’honoraires et/ou vous souhaitez des remboursements à hauteur de 100 % de la base de remboursement, c’est-à-dire une prise en charge limitée au ticket modérateur.",
    },
    {
        label: "Moyen",
        value: 2,
        description:
            "Vous consultez des médecins pratiquant de faibles dépassements d’honoraires et souhaitez une prise en charge entre 101 % et 150 % de la base de remboursement.",
    },
    {
        label: "Fort",
        value: 3,
        description:
            "Vous consultez des médecins pratiquant de forts dépassements d’honoraires et souhaitez une prise en charge entre 151 % et 200 % de la base de remboursement.",
    },
    {
        label: "Maximum",
        value: 4,
        description:
            "Vous consultez des médecins pratiquant de très forts dépassements d’honoraires et souhaitez une prise en charge de plus de 200 % de la base de remboursement afin de limiter au maximum votre reste à charge.",
    },
];

const ReimbursementLevel = () => {
    return (
        <div className="static-slider__wrapper">
            {LEVELS.map(({ label, value, color, description }) => (
                <div className="static-slider" key={label}>
                    <div className="static-slider--bar">
                        <div className="static-slider--track" style={{ width: `${(value / 4) * 100}%` }} />
                        <div className="circle" style={{ left: `${(value / 4) * 100}%` }}>
                            <div className="static-slider--marker" >{label}</div>
                            <div
                                className="static-slider--thumb"
                            />
                        </div>
                        <div className="divider" />
                    </div>
                    <div className="static-slider--description">
                        <span>Niveau {label} :</span>
                        <p>{description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ReimbursementLevel;
